import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sadieSimulatorThreadQueryKey } from "@/hooks/queries/useGetSadieSimulatorThread";
import { guacHttpClient } from "@/lib/http";
import {
  SadieSimulatorPromptChangesRequest,
  SadieSimulatorThread,
} from "@/types";

// Saves every prompt change at once, in place of the ones before. They apply
// from Sadie's next turn.
export function useUpdateSetSadieSimulatorPromptChanges() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: SadieSimulatorPromptChangesRequest) => {
      await guacHttpClient.post(
        "relationships/simulator/prompt-changes",
        request,
      );
    },
    onSuccess: (_data, { talentId, changes }) => {
      queryClient.setQueryData<SadieSimulatorThread>(
        sadieSimulatorThreadQueryKey(talentId),
        (thread) =>
          thread?.simulator
            ? {
                ...thread,
                simulator: { ...thread.simulator, promptChanges: changes },
              }
            : thread,
      );
    },
  });
}
